export function getSSORedirectUrl(config) {
  if (!config || !config.sso || !config.sso.clientId || !config.sso.redirectUrl) {
    return '/';
  }

  const { clientId, redirectUrl } = config.sso;
  return `authorize?response_type=code&scope=openid&client_id=${clientId}&redirect_uri=${redirectUrl}`;
}
